import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-paginator',
  imports: [
    CommonModule,
    FormsModule,
    PaginatorModule,
    SelectModule
  ],
  templateUrl: './paginator.html',
  styleUrl: './paginator.scss',
})
export class Paginator {
  first = input<number>(); // Primera fila a mostrar por página
  rows = input<number>(); // Cantidad de filas por página
  totalRecords = input.required<number>(); // Total de registros
  rowsPerPageOptions = input<number[]>([10, 25, 50]);
  
  pageChange = output<PaginatorState>();

  selectedRowsPerPage: number = this.rows() || 10;

  onPageChange(event: PaginatorState) {
    this.pageChange.emit({
      first: event.first ?? 0,
      rows: event.rows ?? 10,
      page: event.page ?? 0
    });
  }

  onRowsChange(value: number) {
    this.pageChange.emit({
      first: 0,
      rows: value,
      page: 0
    });
  }
}
